import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {ActivatedRoute} from '@angular/router';
import {LeadFormLuigiContext} from '@app/product/lead/lead.model';
import {TransactionListCta} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class LuigiLeadService {

  constructor(private oAuthService: OAuthService) {
  }

  public setLuigiContext(buttonText: string, productCode: string, account: string, requiredRegistration: string, entitlementRuleCode: string, action: string, campaignData: string, mediaParameters: string): LeadFormLuigiContext {
    return {
      idToken: this.oAuthService.getAccessToken(),
      buttonText,
      productCode,
      account,
      requiredRegistration,
      entitlementRuleCode,
      action,
      campaignData,
      mediaParameters
    };
  }

  public setLuigiContextFromTransactionType(transactionType: TransactionListCta) {
    if (!transactionType?.targetUrl || transactionType?.targetUrl === '') {
      return {
        idToken: this.oAuthService.getAccessToken(),
        buttonText: transactionType.name
      }
    }
    const url = new URL(transactionType?.targetUrl);

    return this.setLuigiContext(
      transactionType.name,
      url.searchParams.get('product'),
      url.searchParams.get('account'),
      url.searchParams.get('requiredRegistration'),
      url.searchParams.get('entitlementRuleCode'),
      url.searchParams.get('action'),
      url.searchParams.get('campaignData'),
      url.searchParams.get('mediaParamters')
    );
  }

  public setLuigiContextFromRoute(activatedRoute: ActivatedRoute) {
    return this.setLuigiContext(
      activatedRoute.snapshot.queryParamMap.get('buttonText'),
      activatedRoute.snapshot.paramMap.get('product'),
      activatedRoute.snapshot.queryParamMap.get('account'),
      activatedRoute.snapshot.queryParamMap.get('requiredRegistration'),
      activatedRoute.snapshot.queryParamMap.get('entitlementRuleCode'),
      activatedRoute.snapshot.queryParamMap.get('action'),
      activatedRoute.snapshot.queryParamMap.get('campaignData'),
      activatedRoute.snapshot.queryParamMap.get('mediaParameters')
    )
  }

  public updateContext(context: LeadFormLuigiContext, value: {}) {
    return {...context, ...value}
  }
}
